import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Administrator } from 'src/app/core/models/administrator.model';
import { LoggerService } from 'src/app/core/services/logger.service';
import { MustMatch } from 'src/app/core/validators/must-match.validator';
import * as AdministratorActions from 'src/app/manager/administrators/state/administrator.actions';
import * as StaffActions from 'src/app/superuser/staff/state/staff.actions';
import { AdministratorState } from 'src/app/manager/administrators/state/administrator.reducers';
import { Staff } from '../../../core/models/staff.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'cm-set-password-form',
  templateUrl: './set-password-form.component.html',
  styleUrls: ['./set-password-form.component.scss'],
})
export class SetPasswordFormComponent implements OnInit {
  dialogRef: MatDialogRef<SetPasswordFormComponent>;
  userType: string;
  user: any;
  setPasswordForm: UntypedFormGroup;
  hidePassword = true;
  hideConfirmPassword = true;
  passwordStrength = 0;
  passwordStrengthLabel = '';

  constructor(
    private builder: UntypedFormBuilder,
    private logger: LoggerService,
    private store$: Store<AdministratorState>,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.buildForm();
    this.setPasswordForm.get('password').valueChanges.subscribe((value: string) => {
      this.updatePasswordStrength(value || '');
    });
  }

  updatePasswordStrength(password: string): void {
    let score = 0;
    if (password.length >= 8) score++;
    if (password.length >= 12) score++;
    if (/[a-z]/.test(password) && /[A-Z]/.test(password)) score++;
    if (/\d/.test(password)) score++;
    if (/[^a-zA-Z0-9]/.test(password)) score++;

    this.passwordStrength = score;
    const labelKeys = ['', 'WEAK', 'FAIR', 'GOOD', 'STRONG', 'VERY_STRONG'];
    this.passwordStrengthLabel = password.length > 0 && labelKeys[score]
      ? this.translate.instant(`MANAGER.PROFILE.CHANGE_PASSWORD_FORM.STRENGTH.${labelKeys[score]}`)
      : '';
  }

  buildForm(): void {
    this.setPasswordForm = this.builder.group(
      {
        password: ['', [Validators.required, Validators.minLength(8)]],
        confirm_password: ['', [Validators.required, Validators.minLength(8)]],
      },
      { validator: MustMatch('password', 'confirm_password') }
    );
  }

  onSubmit(): void {
    if (this.setPasswordForm.valid) {
      switch (this.userType) {
        case 'administrator':
          let administrator: Administrator = this.user as Administrator;
          administrator = {
            ...administrator,
            password: this.setPasswordForm.get('password').value,
          };
          this.store$.dispatch(
            AdministratorActions.setAdministratorPassword({ administrator })
          );
          break;
        case 'staff':
          let staff: Staff = this.user as Staff;
          staff = {
            ...staff,
            password: this.setPasswordForm.get('password').value,
          };
          this.store$.dispatch(StaffActions.setStaffPassword({ staff }));
          break;
      }

      this.dialogRef.close({ success: true });
    }
  }
}
